import { RouterStore } from "mobx-react-router";

/**
 * @deprecated remove this
 */
export class RoutingStore extends RouterStore {
  // see PR https://github.com/alisd23/mobx-react-router/pull/73
  push = (path, state = undefined) => {
    this.history.push(path, state);
  };

  // see PR https://github.com/alisd23/mobx-react-router/pull/73
  replace = (location, state = undefined) => {
    this.history.replace(location, state);
  };
}
